<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-xs-12 col-sm-12 text-center">
            <h4 class="mt-3">
              <b
                >Edit WallsMan
                <span v-if="data.wm"
                  >{{ data.wm.wm_code }} | {{ data.wm.full_name }}</span
                >
                <i class="far fa-user-edit"></i
              ></b>
            </h4>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>คำนำหน้า:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <select class="form-control" v-model="data.wm.title">
                    <option
                      v-for="value in data.title"
                      :key="value"
                      :value="value"
                    >
                      {{ value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>ชื่อ:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    type="text"
                    v-model="data.wm.first_name"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>นามสกุล:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    type="text"
                    v-model="data.wm.last_name"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12" v-if="data.wm">
              <div
                class="form-group row text-center"
                v-if="data.wm.wm_status != 'quit'"
              >
                <label class="col-sm-2 col-form-label"
                  ><b>บาร์โค้ดรถมอเตอร์ไซค์:&nbsp;</b></label
                >
                <div class="col-sm-10">
                  <treeselect
                    :options="data.bikes"
                    v-model="data.wm.bike_barcode"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>สถานภาพ:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <select class="form-control" v-model="data.wm.marital_status">
                    <option
                      v-for="value in data.marital_status"
                      :key="value"
                      :value="value"
                    >
                      {{ value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>สัญชาติ:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <select class="form-control" v-model="data.wm.nationality">
                    <option
                      v-for="value in data.nationalities"
                      :key="value"
                      :value="value"
                    >
                      {{ value }}
                    </option>
                  </select>
                  <input
                    v-if="data.wm.nationality === other.value"
                    class="form-control"
                    v-model="nationality"
                    type="text"
                    placeholder="กรุณากรอกสัญชาติที่เกี่ยวข้อง"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>วันเกิด(ปี ค.ศ.):&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.date_of_birth"
                    type="date"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>เลขที่บัตรประจำตัวประชาชน:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.citizen_id"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>หมายเลขหนังสือเดินทาง:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.passport_number"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>ขนาดเสื้อ:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.shirt_size"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>ขนาดกางเกง:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.trousers_size"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>ที่อยู่หมายเลข:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.contact_address"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>หมู่:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.moo"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"><b>ซอย:&nbsp;</b></label>
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    v-model="data.wm.soi"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>จังหวัด:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <treeselect
                    :options="data.province"
                    @input="onChangeProvince()"
                    v-model="data.wm.province_id"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"><b>เขต:&nbsp;</b></label>
                <div class="col-sm-10" v-if="data.wm">
                  <select
                    class="form-control"
                    :disabled="
                      !(data.wm.province_id && data.wm.province_id != '')
                    "
                    v-model="data.wm.district_id"
                    @change="onChangeDistrict()"
                  >
                    <option
                      v-for="value in districts"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>แขวง:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <select
                    class="form-control"
                    :disabled="
                      !(data.wm.district_id && data.wm.district_id != '')
                    "
                    v-model="data.wm.sub_district_id"
                    @change="onChangeSubDistrict()"
                  >
                    <option
                      v-for="value in subDistricts"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>รหัสไปรษณีย์:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <select
                    class="form-control"
                    :disabled="
                      !(
                        data.wm.sub_district_id && data.wm.sub_district_id != ''
                      )
                    "
                    v-model="data.wm.post_code_id"
                  >
                    <option
                      v-for="value in post_codes"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.code }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>เบอร์โทรศัพท์:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <input
                    class="form-control"
                    type="text"
                    v-model="data.wm.contact_number"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>เหตุผลการเปลี่ยนแปลง:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <select class="form-control" v-model="data.wm.change_reason">
                    <option
                      v-for="value in data.change_reasons"
                      :key="value"
                      :value="value"
                    >
                      {{ value }}
                    </option>
                  </select>
                  <input
                    v-if="
                      data.wm.change_reason &&
                      other.changeReasons.some((valChangeReason) =>
                        data.wm.change_reason.includes(valChangeReason)
                      )
                    "
                    class="form-control"
                    v-model="change_reason"
                    type="text"
                    placeholder="กรุณากรอกเหตุผลที่เกี่ยวข้อง"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-2 col-form-label"
                  ><b>ผู้รับผลประโยชน์กรณีเกิดอุบัติเหตุ:&nbsp;</b></label
                >
                <div class="col-sm-10" v-if="data.wm">
                  <select class="form-control" v-model="beneficiary.value">
                    <option
                      v-for="value in beneficiary.data"
                      :key="value"
                      :value="value"
                    >
                      {{ value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" v-if="beneficiary.value === 'มี'">
              <div class="col-md-12 col-xs-12 col-sm-12 text-center">
                <h5 class="mt-2">
                  <b>ข้อมูลผู้รับผลประโยชน์กรณีเกิดอุบัติเหตุ</b>
                </h5>
              </div>
              <div class="col-md-12 col-xs-12 col-sm-12">
                <div class="form-group row text-center">
                  <label class="col-sm-2 col-form-label"
                    ><b>ความสัมพันธ์:&nbsp;</b></label
                  >
                  <div class="col-sm-10" v-if="data.wm">
                    <select
                      class="form-control"
                      v-model="data.wm.beneficiary_relationship"
                    >
                      <option
                        v-for="value in data.beneficiary_relationship"
                        :key="value"
                        :value="value"
                      >
                        {{ value }}
                      </option>
                    </select>
                    <input
                      v-if="data.wm.beneficiary_relationship === other.value"
                      class="form-control"
                      v-model="beneficiary.relationship"
                      type="text"
                      placeholder="กรุณากรอกความสัมพันธ์ที่เกี่ยวข้อง"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 col-sm-12">
                <div class="form-group row text-center">
                  <label class="col-sm-2 col-form-label"
                    ><b>คำนำหน้า:&nbsp;</b></label
                  >
                  <div class="col-sm-10" v-if="data.wm">
                    <select
                      class="form-control"
                      v-model="data.wm.beneficiary_title"
                    >
                      <option
                        v-for="value in data.beneficiary_title"
                        :key="value"
                        :value="value"
                      >
                        {{ value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 col-sm-12">
                <div class="form-group row text-center">
                  <label class="col-sm-2 col-form-label"
                    ><b>ชื่อ:&nbsp;</b></label
                  >
                  <div class="col-sm-10" v-if="data.wm">
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.wm.beneficiary_first_name"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 col-sm-12">
                <div class="form-group row text-center">
                  <label class="col-sm-2 col-form-label"
                    ><b>นามสกุล:&nbsp;</b></label
                  >
                  <div class="col-sm-10" v-if="data.wm">
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.wm.beneficiary_last_name"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 col-sm-12">
                <div class="form-group row text-center">
                  <label class="col-sm-2 col-form-label"
                    ><b>เลขที่บัตรประจำตัวประชาชน:&nbsp;</b></label
                  >
                  <div class="col-sm-10" v-if="data.wm">
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.wm.beneficiary_citizen_id"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 col-sm-12">
                <div class="form-group row text-center">
                  <label class="col-sm-2 col-form-label"
                    ><b>เบอร์โทรศัพท์:&nbsp;</b></label
                  >
                  <div class="col-sm-10" v-if="data.wm">
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.wm.beneficiary_contact_number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12 mt-3 mb-4">
              <div class="row">
                <div class="col-md-4 col-xs-4 col-sm-4">
                  <button
                    type="button"
                    class="btn btn-primary form-control"
                    @click="sendAction()"
                  >
                    <i class="far fa-paper-plane"></i> ยืนยันส่งข้อมูล
                  </button>
                </div>
                <div class="col-md-4 col-xs-4 col-sm-4">
                  <router-link :to="{ name: 'WallsmensIndex' }"
                    ><button type="button" class="btn btn-light form-control">
                      <i class="far fa-window-close"></i> ยกเลิก
                    </button></router-link
                  >
                </div>
                <div class="col-md-4 col-xs-4 col-sm-4">
                  <button
                    type="button"
                    class="btn btn-danger form-control"
                    @click="openModal()"
                  >
                    <i class="far fa-suitcase"></i> ลาออก
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :title="modal.title"
      ref="model"
      hide-footer
      v-model="modal.active"
      @ok="closeModal()"
    >
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <div v-html="modal.detail"></div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 mt-2">
              <button
                type="button"
                class="btn btn-danger form-control"
                @click="confirmQuit()"
              >
                <b>ยืนยันการลาออก</b>
              </button>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 mt-2">
              <button
                type="button"
                class="btn btn-light form-control"
                @click="closeModal()"
              >
                <b>ยกเลิก</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <Loading :percent="load.percent" :active="load.active"></Loading>
    <v-dialog />
  </div>
</template>
<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import JWT from "../../utils/JWT.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.use(VModal, { dialog: true });
export default {
  components: {
    treeselect: () => import("@riophae/vue-treeselect"),
    Loading: () => import("../../utils/Loading.vue"),
  },
  data() {
    return {
      modal: {
        title: "ยืนยันการลาออกของวอลล์แมน/วอลล์เลดี้",
        detail: "ยืนยันการลาออกของวอลล์แมน/วอลล์เลดี้",
        active: false,
      },
      alert: {
        message: "",
      },
      post_codes: [],
      subDistricts: [],
      districts: [],
      other: {
        value: "อื่น ๆ",
        changeReasons: ["ทุจริต", "อื่น ๆ"],
      },
      nationality: null,
      change_reason: null,
      beneficiary: {
        relationship: null,
        value: "ไม่มี",
        data: ["ไม่มี", "มี"],
      },
      load: {
        task: 0,
        count: 0,
        percent: 0,
        active: false,
      },
      data: {},
    };
  },
  watch: {
    "data.wm.nationality": {
      handler: function (val) {
        if (val === "ไทย") {
          this.beneficiary.value = "มี";
          this.beneficiary.data = ["มี"];
        } else {
          this.beneficiary.data = ["ไม่มี", "มี"];
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.getWM();
  },
  methods: {
    openModal() {
      this.modal.active = true;
      this.$refs.model.show();
    },
    closeModal() {
      this.$refs.model.hide();
    },
    getSubDistricts() {
      let data = [];
      const subDistricts = this.data.sub_district;
      let districtId = null;
      if (this.data.wm) {
        districtId = this.data.wm.district_id;
      }
      if (subDistricts && districtId && districtId != "") {
        let subDistrict = null;
        for (subDistrict of subDistricts) {
          if (subDistrict.district_id === districtId) {
            data.push(subDistrict);
          }
        }
      }
      return data;
    },
    getPostCodes() {
      let data = [];
      const postCodes = this.data.post_code;
      let subDistrictId = null;
      if (this.data.wm) {
        subDistrictId = this.data.wm.sub_district_id;
      }
      if (postCodes && subDistrictId && subDistrictId != "") {
        let postCode = null;
        for (postCode of postCodes) {
          if (postCode.sub_district_id === subDistrictId) {
            data.push(postCode);
          }
        }
      }
      return data;
    },
    getDistricts() {
      let data = [];
      const districts = this.data.district;
      let provinceId = null;
      if (this.data.wm) {
        provinceId = this.data.wm.province_id;
      }
      if (districts && provinceId && provinceId != "") {
        let district = null;
        for (district of districts) {
          if (district.province_id === provinceId) {
            data.push(district);
          }
        }
      }
      return data;
    },
    onChangeProvince() {
      this.data.wm.district_id = null;
      this.districts = this.getDistricts();
      this.onChangeDistrict();
    },
    onChangeDistrict() {
      this.data.wm.sub_district_id = null;
      this.subDistricts = this.getSubDistricts();
      this.onChangeSubDistrict();
    },
    onChangeSubDistrict() {
      this.data.wm.post_code_id = null;
      this.post_codes = this.getPostCodes();
    },
    async confirmQuit() {
      try {
        let wm = this.data.wm;
        const changeReason = this.change_reason;
        const other = this.other.changeReasons;
        if (other.includes(wm.change_reason) && changeReason) {
          wm.change_reason = changeReason;
        } else {
          wm.change_reason = "ลาออก";
        }
        await this.resetLoading(1);
        await this.$http.post(
          process.env.VUE_APP_AUTH_URL + "api/v1/user/wallsman/wm",
          {
            key: await JWT.encode({
              wm_code: wm.wm_code,
              id: wm.id,
              mini_code: wm.mini_code,
            }),
            data: wm,
          }
        );
        this.load.active = false;
        this.$dialogs.alert(
          "การตรวจสอบการยืนยันลาออก WallsMan Code: " + wm.wm_code,
          { title: "การตรวจสอบการยืนยันลาออก" }
        );
        this.$notify({
          title: "การตรวจสอบการยืนยันลาออก",
          text: "การตรวจสอบการยืนยันลาออก WallsMan Code: " + wm.wm_code,
        });
        this.$router.push({ name: "WallsmensIndex" });
      } catch (error) {
        this.load.active = false;
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert;
          } else {
            this.alert.message =
              "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย";
          }
        } else {
          this.alert.message =
            "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย";
        }
        this.$dialogs.alert(this.alert.message, {
          title: "เกิดข้อผิดพลาดในการดึงข้อมูล",
        });
      }
    },
    async sendAction() {
      let wm = this.data.wm;
      const beneficiary = this.beneficiary;
      const nationality = this.nationality;
      const changeReason = this.change_reason;
      const other = this.other.value;
      const otherChangeReason = this.other.changeReasons;
      if (!wm.bike_barcode || wm.bike_barcode === "") {
        this.$dialogs.alert("กรุณาเลือกบาร์โค้ดรถมอเตอร์ไซค์", {
          title: "กรอกข้อมูลไม่ครบ",
        });
        return;
      }
      if (
        !(
          (wm.citizen_id && wm.citizen_id !== "") ||
          (wm.passport_number && wm.passport_number !== "")
        )
      ) {
        this.$dialogs.alert(
          "กรุณากรอกเลขที่บัตรประจำตัวประชาชนหรือหมายเลขหนังสือเดินทาง",
          {
            title: "กรอกข้อมูลไม่ครบ",
          }
        );
        return;
      }
      if (
        beneficiary.value === "มี" &&
        !(
          wm.beneficiary_first_name &&
          wm.beneficiary_first_name !== "" &&
          wm.beneficiary_last_name &&
          wm.beneficiary_last_name !== "" &&
          wm.beneficiary_relationship &&
          wm.beneficiary_relationship != "" &&
          wm.beneficiary_title &&
          wm.beneficiary_title !== "" &&
          wm.beneficiary_citizen_id &&
          wm.beneficiary_citizen_id !== "" &&
          wm.beneficiary_contact_number &&
          wm.beneficiary_contact_number !== ""
        )
      ) {
        this.$dialogs.alert(
          "กรุณากรอกข้อมูลผู้รับผลประโยชน์กรณีเกิดอุบัติเหตุทั้งหมด",
          {
            title: "กรอกข้อมูลไม่ครบ",
          }
        );
        return;
      }
      if (!wm.date_of_birth) {
        this.$dialogs.alert("กรุณาเลือกวันเดือนปีเกิด", {
          title: "กรอกข้อมูลไม่ครบ",
        });
        return;
      }
      if (!wm.first_name || !wm.last_name) {
        this.$dialogs.alert("กรุณากรอกชื่อ", {
          title: "กรอกข้อมูลไม่ครบ",
        });
        return;
      }
      if (wm.beneficiary_relationship === other && beneficiary.relationship) {
        wm.beneficiary_relationship = beneficiary.relationship;
      }
      if (wm.nationality === other && nationality) {
        wm.nationality = nationality;
      }
      if (changeReason && otherChangeReason.includes(wm.change_reason)) {
        if (changeReason.includes(wm.change_reason)) {
          wm.change_reason = changeReason;
        } else {
          wm.change_reason = `${wm.change_reason}: ${changeReason}`;
        }
      }
      let fullname = null;
      if (wm.first_name) {
        fullname = wm.first_name;
      }
      if (wm.last_name) {
        if (fullname) {
          fullname = fullname + " " + wm.last_name;
        } else {
          fullname = wm.last_name;
        }
      }
      wm.full_name = fullname;
      let beneficiaryFullname = null;
      if (wm.beneficiary_first_name) {
        beneficiaryFullname = wm.beneficiary_first_name;
      }
      if (wm.beneficiary_last_name) {
        if (beneficiaryFullname) {
          beneficiaryFullname =
            beneficiaryFullname + " " + wm.beneficiary_last_name;
        } else {
          beneficiaryFullname = wm.beneficiary_last_name;
        }
      }
      wm.beneficiary_full_name = beneficiaryFullname;
      try {
        await this.resetLoading(1);
        await this.$http.put(
          process.env.VUE_APP_AUTH_URL + "api/v1/user/wallsman/wm",
          {
            key: await JWT.encode({
              wm_code: wm.wm_code,
              id: wm.id,
              mini_code: wm.mini_code,
            }),
            data: wm,
          }
        );
        this.load.active = false;
        this.$dialogs.alert("รอการตรวจสอบ WallsMan Code: " + wm.wm_code, {
          title: "รอการตรวจสอบ",
        });
        this.$notify({
          title: "รอการตรวจสอบ",
          text: "รอการตรวจสอบ WallsMan Code: " + wm.wm_code,
        });
        this.$router.push({ name: "WallsmensIndex" });
      } catch (error) {
        this.load.active = false;
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert;
          } else {
            this.alert.message =
              "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย";
          }
        } else {
          this.alert.message =
            "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย";
        }
        this.$dialogs.alert(this.alert.message, {
          title: "เกิดข้อผิดพลาดในการดึงข้อมูล",
        });
      }
    },
    resetLoading(task) {
      this.load.count = 0;
      this.load.task = task;
      this.load.percent = 0;
      this.load.active = true;
    },
    async getWM() {
      try {
        await this.resetLoading(1);
        this.data = {};
        const body = (
          await this.$http.get(
            process.env.VUE_APP_AUTH_URL +
              "api/v1/user/wallsman/wm/" +
              (await JWT.encode({
                id: this.$route.params.wm_id,
              }))
          )
        ).body;
        const {
          wm,
          beneficiary_relationship: beneficiaryRelationships,
          change_reasons: changeReasons,
          nationalities,
        } = body;
        if (
          (wm && wm.beneficiary_title && wm.beneficiary_title !== "") ||
          (wm.beneficiary_first_name && wm.beneficiary_first_name !== "") ||
          (wm.beneficiary_relationship && wm.beneficiary_relationship !== "") ||
          (wm.beneficiary_last_name && wm.beneficiary_last_name !== "") ||
          (wm.beneficiary_citizen_id && wm.beneficiary_citizen_id !== "") ||
          (wm.beneficiary_contact_number &&
            wm.beneficiary_contact_number !== "")
        ) {
          this.beneficiary.value = "มี";
        }
        let value = null;
        const other = this.other.value;
        if (wm.beneficiary_relationship) {
          let isBeneficiaryRelationshipOther = true;
          if (wm.beneficiary_relationship !== other) {
            for (value of beneficiaryRelationships) {
              if (value === wm.beneficiary_relationship) {
                isBeneficiaryRelationshipOther = false;
                break;
              }
            }
          }
          if (isBeneficiaryRelationshipOther) {
            this.beneficiary.relationship = wm.beneficiary_relationship;
            body.wm.beneficiary_relationship = other;
          }
        }
        if (wm.nationality) {
          let isNationalityOther = true;
          if (wm.nationality !== other) {
            for (value of nationalities) {
              if (value === wm.nationality) {
                isNationalityOther = false;
                break;
              }
            }
          }
          if (isNationalityOther) {
            this.nationality = wm.nationality;
            body.wm.nationality = other;
          } else if (wm.nationality === "ไทย") {
            this.beneficiary.data = ["มี"];
          }
        }
        if (wm.change_reason) {
          let isChangeReasonOther = true;
          this.change_reason = wm.change_reason;
          changeReasons.some((valOther) => {
            if (wm.change_reason.includes(valOther)) {
              isChangeReasonOther = false;
              body.wm.change_reason = valOther;
              return true;
            }
            return false;
          });
          if (isChangeReasonOther) {
            body.wm.change_reason = other;
          }
        }
        this.data = body;
        this.modal.detail =
          this.modal.detail +
          " WallsMan Code: <b>" +
          this.data.wm.wm_code +
          "</b>";
        this.load.active = false;
      } catch (error) {
        this.load.active = false;
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert;
          } else {
            this.alert.message =
              "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย";
          }
        } else {
          this.alert.message =
            "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย";
        }
        this.$dialogs.alert(this.alert.message, {
          title: "เกิดข้อผิดพลาดในการดึงข้อมูล",
        });
      }
    },
  },
};
</script>
